
import { defineComponent } from "vue";
import { BaseModal } from "@/components/shared/modal";

export default defineComponent({
  name: "custom-dialog",

  components: { BaseModal },

  emits: ["on-close-icon-click"],

  props: {
    title: {
      type: String,
      required: true,
    },
    isDisplay: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default: "50%",
    },
    size: {
      type: String,
      default: "",
      validator: (value: string) =>
        ["", "sm", "lg", "xl", "xxl"].includes(value),
    },
    /** When true, clicking outside the dialog dismisses it. Default: false (static backdrop). */
    closeOnBackdropClick: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onCloseIconClickedHandler() {
      this.$emit("on-close-icon-click");
    },
  },
});
